import { choirDE, choirEN, bioDE, bioEN, projectsDE, projectsEN, arrangementsDE, arrangementsEN } from './choirleader';
import { vocalDE, vocalEN } from './vocalcoach'
// import { arrangementsDE, arrangementsEN } from './arrangements'
import { landingDE, landingEN } from './landing'

const pages = {
    name: 'pages',
    label: 'Pages',
    files: [
        landingDE, landingEN, choirDE, choirEN,
        bioDE, bioEN, projectsDE, projectsEN,
        vocalDE, vocalEN, arrangementsDE, arrangementsEN
    ],
};

export default pages;